import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import CodeOfConduct from "@/pages/CodeOfConduct";
import Privacy from "@/pages/Privacy";
import Sponsorship from "@/pages/Sponsorship";
import TechLeaders from "@/pages/TechLeaders";
import TechLeadersBrochure from "@/pages/TechLeadersBrochure";
import PaymentTerms from "@/pages/PaymentTerms";
import InternationalPay from "@/pages/InternationalPay";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/code-of-conduct" element={<CodeOfConduct />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/sponsorship" element={<Sponsorship />} />
          <Route path="/tech-leaders" element={<TechLeaders />} />
          <Route path="/tech-leaders/brochure" element={<TechLeadersBrochure />} />
          <Route path="/payment-terms" element={<PaymentTerms />} />
          <Route path="/international-pay" element={<InternationalPay />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
